module.exports = __webpack_public_path__ + "static/media/customchannels.e6cf5daa.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/customchannels.png
// module id = 193
// module chunks = 0